import { render, staticRenderFns } from "./WorkRelationReport.vue?vue&type=template&id=666e63e9&scoped=true&"
import script from "./WorkRelationReport.vue?vue&type=script&lang=ts&"
export * from "./WorkRelationReport.vue?vue&type=script&lang=ts&"
import style0 from "./WorkRelationReport.vue?vue&type=style&index=0&id=666e63e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e63e9",
  null
  
)

export default component.exports